const previewLimit = 512 * 1024

export async function readTextPreview(blob: Blob): Promise<string> {
  if (blob.size > previewLimit) {
    throw new Error(
      "This file is too large to preview. Download it to read the full text."
    )
  }

  return await blob.text()
}
